import React from 'react';
import classnames from 'classnames';
import { PapiDeviationPoll } from '@wix/da-papi-types';
import MinimalDumbo from '../MinimalDumbo';
import TextRenderer from '../../../TextRenderer';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import PollTiptapViewer from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Poll';

import pollStyles from './Poll.scss';

export interface Props {
  poll: PapiDeviationPoll;
}

const Answer: React.FC<PapiDeviationPoll['answers'][0]> = ({
  textContent,
  image,
  answerId,
  percentvotes,
}) => {
  return (
    <li className={classnames(pollStyles['answer'], pollStyles['answer-voted'])}>
      <div className={pollStyles['answer-row']}>
        {image && (
          <MinimalDumbo
            deviation={image}
            className={pollStyles['pollimage']}
            width={72}
            height={72}
          />
        )}
        <TextRenderer
          htmlExcerptLegacy
          isPollWithHtmlExcerpt
          textContent={textContent}
          className={classnames(pollStyles['answer-text'], 'da-editor-poll-thumb')}
          viewerKey={answerId}
          tipTapViewer={PollTiptapViewer}
          cookieType={MeasuredCookieType.EDITOR_POLL}
        />
        <div className={pollStyles['percent']}>{percentvotes}%</div>
      </div>
      <div className={pollStyles['bar-wrapper']}>
        <div className={pollStyles['bar']} style={{ width: `${percentvotes}%` }} />
      </div>
    </li>
  );
};

const VotedAnswers: React.FC<Props> = ({ poll }) => {
  return (
    <ul className={classnames(pollStyles['voted'], pollStyles['answers'])}>
      {poll.answers.map(answer => (
        <Answer {...answer} key={`answer:${answer.answerId}`} />
      ))}
    </ul>
  );
};

export default VotedAnswers;
